module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs"
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberOfTeachersThatCreatedAtLeastOneRt) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Teachers That Created At Least One Roundtable\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.teachers_that_created_at_least_one_roundtable),
      expression: "teachers_that_created_at_least_one_roundtable"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs"
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberActiveStudents) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Active Students\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.teachers_that_created_at_least_one_roundtable),
      expression: "teachers_that_created_at_least_one_roundtable"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs"
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberOfTeachersThatRanAtLeastOneRt) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Teachers That Ran At Least One Roundtable\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.teachers_that_ran_at_least_one_roundtable),
      expression: "teachers_that_ran_at_least_one_roundtable"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-button pl-box-shadow pa2 center-xs cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('showRoundtablesInfo', 'daily_list_of_roundtables_created')
      }
    }
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberActivitiesCreated) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Written RoundTables Created\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_created_tooltip),
      expression: "roundtable_discussions_created_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs",
    on: {
      "click": function($event) {
        return _vm.$emit('showRoundtablesInfo', 'daily_list_of_roundtables_run')
      }
    }
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberActivitiesRun) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label cursor-pointer"
  }, [_vm._v("\n      Written RoundTables Run\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_run_tooltip),
      expression: "roundtable_discussions_run_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('showRoundtablesInfo', 'daily_list_of_live_discussions_created')
      }
    }
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberOfLiveDiscussionsCreated) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Verbal RoundTables Created\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.live_discussions_created_tooltip),
      expression: "live_discussions_created_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.$emit('showRoundtablesInfo', 'daily_list_of_live_discussions_run')
      }
    }
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberOfLiveDiscussionsRun) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      Verbal RoundTables Run\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.live_discussions_run_tooltip),
      expression: "live_discussions_run_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "general-info-card pl-box-shadow pa2 center-xs"
  }, [_c('div', {
    staticClass: "general-info-data mv3"
  }, [_vm._v("\n      " + _vm._s(_vm.numberOfRtsCreatedFromUniverse) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row col-xs no-margin no-padding middle-xs center-xs general-info-label"
  }, [_vm._v("\n      RoundTables Created From Universe\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('i', {
    directives: [{
      name: "my-tooltip",
      rawName: "v-my-tooltip",
      value: (_vm.roundtable_discussions_created__from_universe_tooltip),
      expression: "roundtable_discussions_created__from_universe_tooltip"
    }],
    staticClass: "fa fa-info-circle",
    staticStyle: {
      "color": "#848484"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-04637f08!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/adminPortalParlay/adminPortalParlayAnalytics/adminViewAnalyticsGeneralInfo.vue
// module id = 2206
// module chunks = 61